import { useTranslation } from "react-i18next";

import { IRuleMovementConditions } from "interfaces/rules.interface";

import { InfoField } from "./InfoField";

type LogPresetMovementProps = {
  preset: IRuleMovementConditions;
};

export function LogPresetMovement({ preset }: LogPresetMovementProps) {
  const { t } = useTranslation();

  return (
    <>
      <InfoField
        label={t("minimum_time_presence_is")}
        value={(preset.initial_presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={t("average_movement_in_the_last")}
        value={(preset.movement_mean_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={t("is_greater_than_or_equal_to")}
        value={preset.movement_mean_gte}
      />
    </>
  );
}
